import { Helmet } from "react-helmet-async";
import { useGlobalSettings } from "@/hooks/useGlobalSettings";

interface LocalBusinessSchemaProps {
  pageUrl?: string;
}

const LocalBusinessSchema = ({ pageUrl = "https://mycleanexteriors.co.uk" }: LocalBusinessSchemaProps) => {
  const { data: settings } = useGlobalSettings();

  const schema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "@id": `${pageUrl}#business`,
    name: settings?.site_name || "MyClean Exteriors",
    description: "Professional pressure washing, soft washing and surface restoration for homes and managed properties across Bournemouth and Poole.",
    url: pageUrl,
    telephone: settings?.phone || "01202 XXX XXX",
    email: settings?.email || "hello@mycleanexteriors.co.uk",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Poole",
      addressRegion: "Dorset",
      addressCountry: "GB",
      streetAddress: settings?.address || "Poole, Dorset"
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 50.7192,
      longitude: -1.9817
    },
    areaServed: [
      { "@type": "City", name: "Bournemouth" },
      { "@type": "City", name: "Poole" },
      { "@type": "City", name: "Christchurch" },
      { "@type": "City", name: "Ferndown" },
      { "@type": "City", name: "Wimborne" }
    ],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Saturday",
        opens: "09:00",
        closes: "16:00"
      }
    ],
    priceRange: "££",
    image: `${pageUrl}/og-image.jpg`,
    sameAs: [
      settings?.social_facebook,
      settings?.social_instagram
    ].filter(Boolean),
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Exterior Cleaning Services",
      itemListElement: [
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Driveway Cleaning" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Patio Cleaning" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Soft Washing" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Moss Removal" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Surface Restoration" } }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
